import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { API_URL } from '../../../config';

function FormAddAdmin() {
  // Gestion des inputs
  const [password, setPassword] = useState("");
  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [role, setRole] = useState(""); // Nouveau state pour le select
  const [loading, setLoading] = useState(false); // chargement de l'état d'ajout

  // Gestion de l'image
  const [file, setFile] = useState(null); // Contient le fichier sélectionné
  const [preview, setPreview] = useState(null); // URL de prévisualisation

  // Gestion des messages
  const [message, setMessage] = useState("");
    const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("password", password);
    formData.append("email", email);
    formData.append("name", name);
    formData.append("role", role);
    if (file) {
      formData.append("images", file); // Ajout du fichier si disponible
    }

    
    setLoading(true);

    try {
      const response = await fetch(`${API_URL}/api/user/addadmin`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`, // Ajout du token si nécessaire
        },
        body: formData,
      });

      const data = await response.json();
      if (response.ok) {
        setLoading(false);
        setMessage("Administrateur ajouté avec succès !");
        setTimeout(() => {
          navigate(0); // Cela recharge la page actuelle
        }, 2000);
      } else {
        setLoading(false);
        setMessage(data.message || "Erreur lors de l'ajout.");
      }
    } catch (err) {
      console.error(err);
      setLoading(false);
      setMessage("Une erreur est survenue.");
    }
  };

  const handleImageChange = (e) => {
    const fileU = e.target.files[0];
    if (fileU) {
      setFile(fileU);
      setPreview(URL.createObjectURL(fileU)); // Génère une URL pour prévisualiser l'image
    }
  };

  return (
    <form className="col" onSubmit={handleSubmit}>
      <div className="row">
        {/* Section image */}
        <div className="col-lg-4">
          <div className="card mb-3">
            <div className="card-body text-center shadow">
              <img
                className="rounded-circle mb-3 mt-4"
                src={preview || "assets/img/dogs/groupinLogo.svg"}
                width="160"
                height="160"
                style={{ border: "1px solid #4e73df" }}
                alt="Logo"
              />
              <div className="mb-3">
                <label htmlFor="fileUpload" className="btn btn-primary btn-sm">
                  Ajouter une photo
                </label>
                <input
                  id="fileUpload"
                  type="file"
                  accept="image/*"
                  onChange={handleImageChange}
                  style={{ display: "none" }}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Section formulaire */}
        <div className="col-lg-8">
          <div className="card shadow mb-3">
            <div className="card-header py-3">
              <p className="text-primary m-0 fw-bold">
                Ajouter un administrateur
              </p>
            </div>
            <div className="card-body">
              {/* Ligne 1 : Mot de passe / Adresse mail */}
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="password">
                      <strong>Mot de passe</strong>
                    </label>
                    <input
                      className="form-control"
                      type="password"
                      id="password"
                      name="password"
                      placeholder="************"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                </div>

                <div className="col">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="email">
                      <strong>Adresse mail</strong>
                    </label>
                    <input
                      className="form-control"
                      type="email"
                      id="email"
                      name="email"
                      placeholder="user@example.com"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>
              </div>

              {/* Ligne 2 : Nom / Rôle */}
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="name">
                      <strong>Nom</strong>
                    </label>
                    <input
                      className="form-control"
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Doe"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label" htmlFor="roleSelect">
                      <strong>Rôle</strong>
                    </label>
                    <select
                      className="form-select"
                      id="roleSelect"
                      aria-label="Default select example"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="" disabled>
                        Sélectionnez un rôle
                      </option>
                      <option value="admin1">Administrateur</option>
                      <option value="admin2">Gestionnaire</option>
                      <option value="superUser">Super utilisateur</option>
                    </select>
                  </div>
                </div>
              </div>
              {/* Bouton de soumission */}
              <div className="mb-3">
                <button className="btn btn-primary btn-sm" type="submit" disabled={loading}>
                  {loading ? "Chargement..." : 'Ajouter'}
                </button>
              </div>
              {/* Affichage du message */}
              {message && (
                <div className="alert alert-info mt-3" role="alert">
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

export default FormAddAdmin;